var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fetching)?_c('div',{staticClass:"w-full flex items-center justify-center my-12"},[_c('base-icon',{staticClass:"icon-spin text-primary-light text-5xl",attrs:{"icon":"spinner2"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }